
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.468 10.482c-.6.144-1.145.373-1.61.673-.835.54-1.441 1.35-1.441 2.301v.516c0 .32.291.611.611.611h7.945c.32 0 .61-.291.61-.61v-.517c0-.95-.606-1.76-1.441-2.3a5.202 5.202 0 00-1.61-.674A6.564 6.564 0 0010 10.305c-.537 0-1.052.062-1.532.177zm.228-1.236a2.124 2.124 0 002.609 0 2.14 2.14 0 00.834-1.69A2.148 2.148 0 0010 5.415a2.148 2.148 0 00-2.139 2.14c0 .684.328 1.297.835 1.69zm3.812 2.889c-.62-.401-1.49-.663-2.508-.663-1.017 0-1.887.262-2.508.663-.617.399-.89.872-.908 1.281h6.832c-.017-.41-.29-.882-.908-1.281zM10 6.583a.982.982 0 00-.972.972c0 .53.443.973.972.973.53 0 .973-.443.973-.973A.982.982 0 0010 6.583z","fill":"#9D4B72"}}),_c('rect',{attrs:{"x":"2.367","y":"4.034","width":"15.267","height":"11.933","rx":"2.3","stroke":"#9D4B72","stroke-width":"1.4"}})])
          )
        }
      }
    